<template>
  <div id="basic">
    <div class="top_name">
      <div class="name_list">
        <div class="name_color">活动优惠券</div>
        <div>0</div>
      </div>
      <div class="name_list">
        <div class="name_color">活动优惠券</div>
        <div>0</div>
      </div>
      <div class="name_list">
        <div class="name_color">活动优惠券</div>
        <div>0</div>
      </div>
    </div>
    <div class="top_div">
      <el-form :inline="true" :model="formInline">
        <div class="bottom_center_TO">
          <div class="bottom_center_TO_s">
            <h3>优惠券列表</h3>
            <el-button
              type="primary"
              class="vubutton"
              :header-cell-style="
                () => 'text-align: center;background:#eef1f6;'
              "
              @click="onSubmit"
              >+新增</el-button
            >
          </div>
          <el-radio-group
            class="bottom_centers"
            v-model="radio3"
            size="small"
            fill="#1890ff"
          >
            <el-radio-button label="全部"></el-radio-button>
            <el-radio-button label="准备中"></el-radio-button>
            <el-radio-button label="进行中"></el-radio-button>
            <el-radio-button label="已作废"></el-radio-button>
            <el-radio-button label="已结束"></el-radio-button>
            <el-radio-button label="已过期"></el-radio-button>
          </el-radio-group>
        </div>
      </el-form>

      <el-table
        :fit="false"
        border
        :data="tableData"
        style="width: auto;"
        :cell-style="() => 'text-align: center;'"
        :header-cell-style="() => 'text-align: center;background:#eef1f6;'"
      >
        <template slot="empty">
          <noCart></noCart>
        </template>
        <el-table-column label="名称" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.date }}</span>
          </template>
        </el-table-column>
        <el-table-column label="日期" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="折扣" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="投放总量" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>

        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        background
        layout="prev, pager, next"
        :total="1000"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: 'employee',
  data() {
    return {
      formInline: {
        user: '',
        region: '',
      },
      tableData: [],
      radio3: '全部',
    };
  },
  methods: {
    onSubmit() {
      console.log('submit!');
    },
    handleEdit(index, row) {
      console.log(index, row);
    },
    handleDelete(index, row) {
      console.log(index, row);
    },
  },
};
</script>

<style scoped>
#basic {
  width: 100%;
  height: 100%;
  position: relative;
}
.top_div {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 20px;
  background: #fff;
}
.demo-form-inline {
  display: flex;
  justify-content: flex-start;
}
/* .el-select > .el-input,
.el-input__inner {
  width: 300px;
} */
.vubutton {
  background: #fff;
  border: solid 1px #1890ff;
  color: #1890ff;
  margin-left: 20px;
}
.el-button--primary:hover,
.el-button--primary:active,
.el-button--primary:focus {
  background: #1890ff;
  border-color: #1890ff;
}
.el-table--group::after,
.el-table--border::after,
.el-table::before {
  background: none;
}
.el-form--inline .el-form-item {
  margin-right: 50px;
}
.center_div {
  margin-top: 20px;
  background: #fff;
  box-sizing: border-box;
  padding: 20px;
}
.el-table__empty-block {
  width: none !important;
}
.center_div_border {
  margin-top: 20px;
  width: 100%;
  min-height: 300px;
  background: brown;
}
.pagination {
  margin-top: 20px;
  text-align: center;
}
.bottom_center_TO {
  width: 100%;
  display: flex;
  margin-bottom: 20px;
  justify-content: space-between;
  align-items: center;
}
.bottom_center_TO_s {
  display: flex;
  justify-content: start;
  align-items: center;
}
.top_name {
  width: 100%;
  height: 109px;
  background: #fff;
  margin-bottom: 20px;
  display: flex;
  box-sizing: border-box;
  padding: 20px 0;
}
.name_list {
  width: 200px;
  height: 100%;
  border-right: solid 1px rgba(0, 0, 0, 0.5);
  text-align: center;
  font-size: 20px;
}
.name_color {
  color: rgba(0, 0, 0, 0.5);
  margin-bottom: 10px;
}
.bottom_centers {
  position: relative;
  right: 0;
}
</style>
